import { createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a72f24b")

_pushScopeId("data-v-2a72f24b")
const _hoisted_1 = {
  class: "my-3",
  for: "projectAddress"
}
const _hoisted_2 = {
  ref: "mapContainer",
  style: {"width":"100%","height":"400px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("input", {
      ref: "autocompleteInput",
      type: "text",
      placeholder: _ctx.$t('project_address_placeholder'),
      class: "form-control",
      disabled: !_ctx.isEdit
    }, null, 8, ["placeholder", "disabled"]),
    _createVNode("p", _hoisted_1, [
      _createVNode("b", null, _toDisplayString(_ctx.address), 1)
    ]),
    _createVNode("div", _hoisted_2, null, 512)
  ], 64))
})